import { render } from "./CountApp.vue?vue&type=template&id=45df8d01&scoped=true"
import script from "./CountApp.vue?vue&type=script&lang=js"
export * from "./CountApp.vue?vue&type=script&lang=js"

import "./CountApp.vue?vue&type=style&index=0&id=45df8d01&scoped=true&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45df8d01"]])

export default __exports__